export const navigationSchema = {
  "@context": "https://schema.org",
  "@type": "SiteNavigationElement",
  "name": "Main Navigation",
  "hasPart": [
    {
      "@type": "WebPage",
      "name": "Video Tutorials",
      "url": "/video-tutorials",
      "@id": "/video-tutorials"
    },
    {
      "@type": "WebPage",
      "name": "Getting Started",
      "url": "/sign-up",
      "@id": "/sign-up"
    }
  ]
};